import styled from 'styled-components';

import { DEVICE } from '@hero/constants';

const Verification = styled.div`
  background-color: var(--color-bg-body);
  border: 1px solid var(--color-border-default);
  border-radius: var(--size-border-radius-md);
  padding: 40px;
  width: 458px;

  ${DEVICE.mobile.max} {
    padding: 24px;
    width: 100%;
  }
`;

const CodeInput = styled.input`
  border: 1px solid var(--color-accent-secondary-weaker);
  border-radius: var(--size-border-radius-md);
  font-size: 24px;
  font-weight: bold;
  height: 64px;
  line-height: 36px;
  text-align: center;
  width: 100%;

  &:not(:last-child) {
    margin-right: 12px;
  }

  &:focus {
    outline: none;
  }

  ${DEVICE.mobile.max} {
    font-size: 15px;
    height: 30px;
    margin-right: 6px;
    width: 30px;
  }
`;

const VerificationResend = styled.span``;

const CodeInputs = styled.div`
  align-items: center;
  display: flex;
  justify-content: center;
`;

const CodeInputSeparator = styled.span`
  color: var(--color-fg-default);
  font-size: 24px;
  font-weight: bold;
  margin-right: 12px;
`;

const VerificationFooter = styled.div`
  color: var(--color-accent-secondary-default);
  display: flex;
  justify-content: space-between;
  margin-top: 8px;
`;

const VerificationBack = styled.button`
  align-items: center;
  background: transparent;
  border: none;
  color: var(--color-accent-secondary-default);
  cursor: pointer;
  display: flex;
  font-size: 16px;
  line-height: 24px;
  outline: none;
`;

const VerificationBody = styled.div`
  border: 1px solid var(--color-accent-primary-weakest);
  border-radius: var(--size-border-radius-md);
  margin-top: 8px;
`;
const VerificationHeader = styled.div`
  display: flex;
`;

export {
  CodeInput,
  CodeInputSeparator,
  CodeInputs,
  Verification,
  VerificationBack,
  VerificationBody,
  VerificationFooter,
  VerificationHeader,
  VerificationResend
};
